import { track } from '@mobi/account/Utils/analytics'
import { capitalize } from '@mobi/utils/string'
import { IdentityVerificationMethod } from '../typings/types'
import { MedicareCardColor } from '../../SignUp/Components'

export type VerificationAnalyticsKey = 'verification_process'

export type VerificationSuccessStep = 'Verified Address' | 'Verified Identification'

export type VerificationProcessEvent = {
  interaction_type: 'Select Option' | 'Contact Us' | 'Success'
  location: string | undefined
  medicareColour: MedicareCardColor | undefined
  message: string | undefined
  optionSelected: string | undefined
  previousStep: VerificationSuccessStep | undefined
  repeatAttempt: string | undefined
  verifyResult: 'Success' | 'Fail' | undefined
}

const defaultVerificationProcessValues: Omit<VerificationProcessEvent, 'interaction_type'> = {
  location: undefined,
  medicareColour: undefined,
  message: undefined,
  optionSelected: undefined,
  previousStep: undefined,
  repeatAttempt: undefined,
  verifyResult: undefined,
}

export const verificationProcessTracker = (event: VerificationProcessEvent) =>
  track('verification_process', event)

export const trackVerificationSuccess = (
  previousStep: VerificationSuccessStep,
  optionSelected?: IdentityVerificationMethod,
  medicareColour?: MedicareCardColor | null
) =>
  verificationProcessTracker({
    interaction_type: 'Success',
    ...defaultVerificationProcessValues,
    optionSelected: optionSelected ? capitalize(optionSelected) : undefined,
    medicareColour: medicareColour ?? undefined,
    previousStep,
  })
